export default class CompanyOfferReport {
  selectJobType(btn, jobTypeNameId, jobTypeInp, showModalId = null) {
    let modal = $(btn).closest('#jobTypeModal');
    let jobTypeSelected = modal.find('input[name="job_type_id"]:checked');

    if (jobTypeSelected.length > 0) {
      let jobTypeNameIdTarget = /^#/.test(jobTypeNameId) ? jobTypeNameId : `#${jobTypeNameId}`;
      $(jobTypeNameIdTarget).text(jobTypeSelected.data('title'));
      $(jobTypeNameIdTarget).removeClass('d-none');

      $(`[name="${jobTypeInp}"]`).val(jobTypeSelected.val());
      $('button[name="select-job-type"]').addClass('d-none');
    }

    modal.modal('hide');

    if (showModalId) {
      let showModalIdTarget = /^#/.test(showModalId) ? showModalId : `#${showModalId}`;
      $(showModalIdTarget).css({ "overflow": "auto" });
      $(showModalIdTarget).modal('show');
    }
  }

  openModal(showModalId, hideModalId = null, inputName = null) {
    if (inputName && !$(`[name="${inputName}"]`).val()) {
      let jobTypeSelected = $('[name="job_type_id"]:checked')
      jobTypeSelected.prop('checked', false);
      jobTypeSelected.closest('.card-wrapper').find('a').click();
    }

    let showModalIdTarget = /^#/.test(showModalId) ? showModalId : `#${showModalId}`;
    if (hideModalId) {
      let hideModalIdTarget = /^#/.test(hideModalId) ? hideModalId : `#${hideModalId}`;
      $(hideModalIdTarget).modal('hide');
    }
    $(showModalIdTarget).modal({ backdrop: 'static', keyboard: false }, 'show');
  }

  backModal(hideModalId, showModalId = null) {
    if (showModalId) {
      let showModalIdTarget = /^#/.test(showModalId) ? showModalId : `#${showModalId}`;
      $(showModalIdTarget).find('.fieldWithErrors').removeClass('fieldWithErrors').addClass('field');
      $(showModalIdTarget).find('.errors').removeClass('errors').addClass('field');
      $(showModalIdTarget).find('.alert.alert-danger').remove();
    }
    this.closeModal(hideModalId, showModalId);
  }

  closeModal(hideModalId, showModalId = null) {
    let hideModalIdTarget = /^#/.test(hideModalId) ? hideModalId : `#${hideModalId}`;
    $(hideModalIdTarget).modal('hide');

    if (showModalId) {
      let showModalIdTarget = /^#/.test(showModalId) ? showModalId : `#${showModalId}`;
      $(showModalIdTarget).css({ "overflow": "auto" });
      $(showModalIdTarget).modal('show');
    }
  }

  hiddenSelectedJob(elm) {
    if ($(elm).prop('checked')) {
      $(elm).closest('.company-offer-report-select-job').find('select').val('')
      $(elm).closest('.company-offer-report-select-job').find('select').prop('disabled', true)
    } else {
      $(elm).closest('.company-offer-report-select-job').find('select').prop('disabled', false)
    }
  }

  removeJobType(elm, inputName = null) {
    $(elm).addClass('d-none').removeClass('d-block');
    $('button[name="select-job-type"]').removeClass('d-none');
    if (inputName) {
      $(`input[name="${inputName}"]`).val('');
    }
  }

  showButtonCompanyOfferReport(target) {
    let val = $(target).val();
    let action = $(target).closest('td').find('.action-company-offer-report');

    if (val && !["first_interview", "second_interview", "third_interview", "forth_interview", "adopt"].includes(val)) {
      action.addClass('d-none');
    } else {
      action.removeClass('d-none');
    }
  }

  handleNumberCurrency(elm, fieldName = null) {
    let value = $(elm).val().replace(/\D/g, '');

    if (fieldName) {
      $(`[name='${fieldName}']`).val($(elm).val() ? value : $(elm).val());
    }
    if (!$(elm).val()) return;

    $(elm).val(new Intl.NumberFormat().format(value));
  }
}
